export const BANKS = [
  {
    id: 71,
    code: "CENAIDJA",
    abbreviation: "BCA",
    value: "014",
    shortLabel: "Bank BCA",
    label: "PT Bank Central Asia Tbk",
  },
  {
    id: 82,
    code: "BNINIDJA",
    abbreviation: "BNI",
    value: "009",
    shortLabel: "Bank BNI",
    label: "PT Bank Negara Indonesia (Persero) Tbk",
  },
  {
    id: 102,
    code: "BRINIDJA",
    abbreviation: "BRI",
    value: "002",
    shortLabel: "Bank BRI",
    label: "PT Bank Rakyat Indonesia (Persero) Tbk",
  },
  {
    id: 120,
    code: "BNIAIDJA",
    abbreviation: "CIMB",
    value: "022",
    shortLabel: "CIMB Niaga",
    label: "PT Bank CIMB Niaga Tbk",
  },
  {
    id: 107,
    code: "BTANIDJA",
    abbreviation: "BTN",
    value: "200",
    shortLabel: "BTN",
    label: "PT Bank Tabungan Negara (Persero) Tbk",
  },
  {
    id: 148,
    code: "BRISIDJA",
    abbreviation: "BSI",
    value: "451",
    shortLabel: "Bank Syariah Indonesia",
    label: "PT Bank Syariah Indonesia Tbk",
  },
  {
    id: 84,
    code: "NISPIDJA",
    abbreviation: "OCBC",
    value: "028",
    shortLabel: "OCBC NISP",
    label: "PT Bank OCBC NISP Tbk",
  },
  {
    id: 67,
    code: "BBBAIDJA",
    abbreviation: "PERMATA",
    value: "013",
    shortLabel: "PermataBank",
    label: "PT Bank Permata Tbk",
  },
  {
    id: 117,
    code: "BDINIDJA",
    abbreviation: "DANAMON",
    value: "011",
    shortLabel: "Bank Danamon",
    label: "PT Bank Danamon Indonesia Tbk",
  },
  {
    id: 118,
    code: "IBBKIDJA",
    abbreviation: "MAYBANK",
    value: "016",
    shortLabel: "Maybank",
    label: "PT Bank Maybank Indonesia Tbk",
  },
  {
    id: 83,
    code: "PINBIDJA",
    abbreviation: "PANIN",
    value: "019",
    shortLabel: "Bank Panin",
    label: "PT Pan Indonesia Bank Tbk",
  },
  {
    id: 13,
    code: "MEGAIDJA",
    abbreviation: "MEGA",
    value: "426",
    shortLabel: "Bank Mega",
    label: "PT Bank Mega Tbk",
  },
  {
    id: 108,
    code: "BTPNIDJA",
    abbreviation: "BTPN",
    value: "213",
    shortLabel: "BTPN",
    label: "PT Bank BTPN Tbk",
  },
  {
    id: 15,
    code: "JAGBIDJA",
    abbreviation: "JAGO",
    value: "542",
    shortLabel: "Bank Jago",
    label: "PT Bank Jago Tbk",
  },
  {
    id: 93,
    code: "BBYBIDJA",
    abbreviation: "NEO",
    value: "490",
    shortLabel: "Bank Neo Commerce",
    label: "PT Bank Neo Commerce Tbk",
  },
  {
    id: 99,
    code: "SEAB",
    abbreviation: "SEABANK",
    value: "535",
    shortLabel: "SeaBank",
    label: "PT Bank Seabank Indonesia",
  },
  {
    id: 137,
    code: "BBKUIDJA",
    abbreviation: "KB BUKOPIN",
    value: "441",
    shortLabel: "KB Bukopin",
    label: "PT Bank KB Indonesia Tbk",
  },
  {
    id: 4,
    code: "BJBRIDJA",
    abbreviation: "BJB",
    value: "110",
    shortLabel: "Bank BJB",
    label: "PT Bank Pembangunan Daerah Jawa Barat dan Banten Tbk",
  },
  {
    id: 5,
    code: "PDJMIDJA",
    abbreviation: "JATIM",
    value: "114",
    shortLabel: "Bank Jatim",
    label: "PT Bank Pembangunan Daerah Jawa Timur Tbk",
  },
  {
    id: 79,
    code: "BCAD",
    abbreviation: "BCA DIGITAL",
    value: "501",
    shortLabel: "BCA Digital",
    label: "PT Bank BCA Digital",
  },
  {
    id: 145,
    code: "ALOBIDJA",
    abbreviation: "ALLO",
    value: "567",
    shortLabel: "Allo Bank",
    label: "PT Allo Bank Indonesia Tbk",
  },
  {
    id: 81,
    code: "MASBIDJA",
    abbreviation: "MAS",
    value: "548",
    shortLabel: "Multiarta Sentosa",
    label: "PT Bank Multiarta Sentosa Tbk",
  },
  {
    id: 562,
    code: "FAMAIDJ1",
    abbreviation: "SUPERBANK",
    value: "superbank",
    shortLabel: "Superbank",
    label: "PT Bank Superbank Indonesia",
  },
  {
    id: 567,
    code: "ALOBIDJA",
    abbreviation: "ALLO",
    value: "allo",
    shortLabel: "Allo Bank",
    label: "PT Allo Bank Indonesia",
  },
  {
    id: 535,
    code: "SSPIIDJA",
    abbreviation: "SEABANK",
    value: "seabank",
    shortLabel: "SeaBank",
    label: "PT Bank Seabank Indonesia",
  },
  {
    id: 542,
    code: "JAGBIDJA",
    abbreviation: "JAGO",
    value: "jago",
    shortLabel: "Bank Jago",
    label: "PT Bank Jago Tbk",
  },
];
